import React, { useState, useEffect, useRef,useContext } from 'react';
import DynamicIcon from '../../components/dynamicicon';
import { Link, useNavigate,useParams  } from 'react-router-dom';
import * as Constants from '../../constants';
import { ShareContext } from '../../context/ShareContext';
import BackLoader from '../../components/backloader';
import JisButton from '../../components/controls/jisButton';
import CaseSearch from '../../components/core/case_search';
import JisEmptyList from '../../components/controls/emptylist';
import Pagenated from '../../components/pagenated';
import moment from 'moment';
function Njc3Report() {
    const {eventtype} = useParams();
  const {judgeid} = useParams();
  const {divisionid} = useParams();
  const {lastdate} = useParams();
  const [judgeName, setJudgeName] = useState('');
  const [division, setDivision] = useState('');

 const navigate = useNavigate();
    const {  activePage, token, profile,frequentData,setIsExpired, setAlert} = useContext(ShareContext);
    const [cases, setCases] = useState([]);
    const [loading, setLoading] =useState(false);

    useEffect(() => {
       onSearch();

       }, []);

const onSearch=async()=>{ 
                ;
            setLoading(true)
            try {
            
            const resp = await fetch(`${Constants.apiUrl}/report/njc-3/${eventtype}/${divisionid}/${judgeid}/${lastdate}`, {
                method: 'GET',
              //  body:JSON.stringify(sear) ,
                headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
            });
            
            const data = await resp.json();
            setLoading(false);
            console.log(data);
            if(data.code==0){
            //update the field
               setCases(data.items)
               setDivision(data.division)
               setJudgeName(data.judgename);
               
            }
             else if(data.code==-10){
                      setIsExpired(true);
                  }
                  else{
            //there is an error
           // setErr(data.status);
            }
            
            } catch (error) {
            setLoading(false);
            console.error(error);
            //setErr(Constants.serverErr);
            // onMove();
            }
        }

  return (
    <div>
        <div>
            <div className='no-print'> <span className='specialaction'>Excel </span> | <span className='specialaction'>Word</span> | <span className='specialaction'>PDF</span>  </div>

            <div style={{textAlign:'center', fontWeight:'bold'}}>NATIONAL JUDICIAL COUNCIL</div>
            <div  style={{textAlign:'center'}}>COMMITTEE ON PERFORMANCE EVALUATION OF JUDICIAL OFFICERS OF SUPERIOR COURTS OF RECORD</div>

            <div style={{marginBottom:16}}>
               <div><strong>STATE: LAGOS</strong></div> 
               <div><strong>COURT:</strong> <span>Room-01 / {division}</span></div>
            </div>
            
            <div>
              <div>DETAILS OF CONSIDERED JUDGEMENTS DURING THE QUARTER ENDED</div>  
              <div>APRIL - JUNE, 2025</div>
            </div>
<div className='table'>
    <table  className="case-table">
  <thead>
    <tr>
      <th>Cases</th>
      <th>(1)<br/>CASES BROUGHT FORWARD FROM LAST QUARTER</th>
      <th>(2)<br/>CASES ASSIGNED THIS QUARTER</th>
      <th>(3)<br/>TOTAL OF 1 AND 2</th>
      <th>(4)<br/>NO. OF CONTESTED CASES AND JUDGEMENT GIVEN</th>
      <th>(5)<br/>NON CONTESTED AND STRUCK OUT CASES</th>
      <th colSpan={2}>(6)<br/>DECISIONS ON INTERLOCUTORY PROCEEDINGS</th>
      <th>(7)<br/>TOTAL NO OF CASES DISPOSED OF DURING THE QUARTER</th>
      <th>(8)<br/>CASES PENDING AT THE END OF THE QUARTER</th>
    </tr>
    <tr>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th>Contested</th>
        <th>Non-Contested</th>
        <th></th>
        <th></th>
    </tr>
  </thead>
  <tbody>
    
     {cases?.map((opt, index) => (
       <tr key={index} >
      <td>{opt.case_Type}</td>
      <td>{opt.previousQuarterScheduled}</td>
       <td>{opt.currentQuarterUnconcluded}</td>
      <td> {opt.totalCount}</td>
      <td>{opt.casesWithMultipleClaimants}</td>
      <td> {opt.casesWithStruckout}</td>
        <td>{opt.interlocContested}</td>
      <td>{opt.interlocNotContested}</td>
       <td>{opt.casesTotalDispose}</td>
      <td>{opt.pendingCases}</td>

    </tr>
    ))} 
    
    <tr style={{fontWeight:'bold'}}>
        <td>Total</td>
        <td>{cases.reduce((sum, item) => sum + item.previousQuarterScheduled, 0)}</td>
        <td>{cases.reduce((sum, item) => sum + item.currentQuarterUnconcluded, 0)}</td>
        <td>{cases.reduce((sum, item) => sum + item.totalCount, 0)}</td>
        <td>{cases.reduce((sum, item) => sum + item.casesWithMultipleClaimants, 0)}</td>
        <td>{cases.reduce((sum, item) => sum + item.casesWithStruckout, 0)}</td>
         <td>{cases.reduce((sum, item) => sum + item.interlocContested, 0)}</td>
        <td>{cases.reduce((sum, item) => sum + item.interlocNotContested, 0)}</td>
        <td>{cases.reduce((sum, item) => sum + item.casesTotalDispose, 0)}</td>
        <td>{cases.reduce((sum, item) => sum + item.pendingCases, 0)}</td>
    </tr>


  </tbody>
</table> 
</div>
            
        <div style={{marginTop:8}}><DynamicIcon iname='asterisk'/> <span style={{fontSize:12}}>* Total Number of Cases Disposed During the Quarter, Column 7 above = Column 4+5.</span></div>
 <div style={{marginTop:8}}><DynamicIcon iname='asterisk'/> <span style={{fontSize:12}}>* Cases Pending at the end of the Quarter, Columns & above = Columns 3 Minus Column 7.</span></div>
<div style={{display:'flex',justifyContent:'space-between', marginTop:24}}>
    <div><strong>NAME OF JUDGE</strong> <span>{judgeName}</span></div>
    <div><strong>CONFIRM BY ME, CHIEF JUDGE</strong> <span>: ____________________</span></div>
</div>

<div style={{display:'flex',justifyContent:'space-between', marginTop:32}}>
    <div><span>Sinature_______________________</span> <span>Date:</span><span>__________________________</span></div>
    <div><span>Sinature_______________________</span> <span>Date:</span><span>__________________________</span></div>
</div>
        </div>
    </div>
  );
}

export default Njc3Report;